import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import { FaMoneyCheckAlt } from 'react-icons/fa';
import { ImSpinner2 } from 'react-icons/im';

function CusDashboard() {
  const [balance, setBalance] = useState("Loading...");
  const [loading, setLoading] = useState(true);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  const ledCode = localStorage.getItem("Ledcode");

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${apiBaseUrl}/user/balance/JAPAN_ACCESORIES/${ledCode}`
        );
        const data = await response.json();

        if (data.success && data.balance) {
          const balanceParts = data.balance.split(' ');
          const formattedBalance = `₹${balanceParts[0]} ${balanceParts[1] === 'Dr' ? '(Debit)' : '(Credit)'}`;
          setBalance(formattedBalance);
        } else {
          setBalance("Balance not available");
        }
      } catch (error) {
        console.error("Error fetching balance:", error);
        setBalance("Error loading balance");
      } finally {
        setLoading(false);
      }
    };

    fetchBalance();
  }, [ledCode]);

  return (
    <div className="min-h-screen flex flex-col bg-[#F7F7F7]">
      {/* Navbar */}
      <div className="sticky top-0 z-50">
        <Navbar />
      </div>

      {/* Header */}
      <div className="w-full bg-gradient-to-r from-[#8b0000] to-[#d78e8e] py-10 text-white text-center">
        <h1 className="text-4xl font-bold mb-2">Welcome to Your Dashboard</h1>
        <p className="text-lg">Check your current account balance below</p>
      </div>

      {/* Balance Section */}
      <div className="flex-grow flex justify-center items-center px-4 py-10 ">
        {loading ? (
          <div className="flex flex-col items-center text-gray-700 text-lg">
            <ImSpinner2 className="animate-spin text-3xl mb-4 text-[#8b0000]" />
            Loading your balance...
          </div>
        ) : (
          <div className="bg-white rounded-2xl shadow-xl p-10 w-full max-w-md text-center transition-transform duration-300 hover:scale-105">
            <FaMoneyCheckAlt className="text-5xl text-[#8b0000] mb-4 mx-auto" />
            <p className="text-lg text-gray-500 mb-2">Available Balance</p>
            <h2 className="text-4xl font-extrabold text-gray-800">{balance}</h2>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="mt-auto bg-[white]">
        <Footer />
      </div>
    </div>
  );
}

export default CusDashboard;
